export default "__VITE_ASSET__e1dd6dfb__"